export const styles = {
	h6: {
		textAlign: 'center',
		paddingBottom: '15px',
	},
	body1: {
		fontSize: '14px',
		color: 'black',
		textAlign: 'center',
		paddingBottom: '15px',
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		maxWidth: '293px',
		margin: 'auto',
	},
	button: {
		width: '100%',
		display: 'block',
		textAlign: 'center',
		padding: '6px 16px',
	},
	contentBox: {
		display: 'flex',
		justifyContent: 'center',
		paddingTop: '15px',
	},
	dialog: {
		zIndex: 2, // This is so that the application Header (z-index = 3) is above the Dialog background
		backdropFilter: 'blur(16px)',
		width: { xs: '100%' },
		' .MuiDialog-container': {
			alignItems: 'center',
			width: '100%',
		},
		' .MuiPaper-root': {
			padding: { xs: '32px', sm: '32px 96px 32px 96px' },
			margin: { xs: 0 },
			maxWidth: { xs: '100%', md: '560px' },
			boxSizing: 'border-box',
			borderRadius: { xs: '16px', md: '32px' },
		},
	},
	label: {
		marginBottom: '20px',
		color: 'grey.600',
		display: 'flex',
	},
	imageContainer: {
		'& img': {
			margin: 'auto',
			display: 'block',
		},
	},
	paragraph: {
		fontSize: '14px',
		color: 'black',
		textAlign: 'center',
	},
	smallHeader: {
		color: '#D32F2F',
		textAlign: 'center',
		paddingBottom: '15px',
	},
}
